import { FormDateField } from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type {
  PLAYER_PORTALS_MODELS,
  SSO_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => FormDateField,
  mapEntryToProps: (
    entry: SSO_MODELS.FormDateField & PLAYER_PORTALS_MODELS.FormDateField,
  ) => kontentAiDataMapping.form_date_field(entry),
};
